import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/Button';
import {PencilGlyph, TrashGlyph} from '../glyphicons/Glyphicons';

const ComplaintPositionTableRow = ({complaintPosition, onDeletePositionBtnClick, onEditPositionBtnClick}) => {
    
    function editPosition(event) {
        event.preventDefault();
        onEditPositionBtnClick(complaintPosition.id);
    }

    function deletePosition(event) {
        event.preventDefault();
        onDeletePositionBtnClick(complaintPosition.id);
    }
    
    return(
        <tr>
            <td>{complaintPosition.id}</td>
            <td>{complaintPosition.product.code}</td>
            <td>{complaintPosition.product.name}</td>
            <td>{complaintPosition.faultDescription}</td>
            <td>
                <Button
                    className="btn icon-btn btn-base btn-grid"
                    name="btnEdit"
                    onClick={editPosition}
                    title="Edytuj">
                    <PencilGlyph className="btn-glyphicon" />
                </Button>
            </td>
            <td>
                <Button
                    className="btn icon-btn btn-base btn-grid"
                    name="btnRemove"
                    onClick={deletePosition}
                    title="Usuń">
                    <TrashGlyph className="btn-glyphicon" />
                </Button>
            </td>
        </tr>
    );
};

ComplaintPositionTableRow.propTypes = {
    complaintPosition: PropTypes.object,
    onDeletePositionBtnClick: PropTypes.func,
    onEditPositionBtnClick: PropTypes.func
};

export default ComplaintPositionTableRow;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositions/ComplaintPositionTableRow.js